import pkg from "../package.json";

export const CONSTANTS = {
    NAME: pkg.name,
    VERSION: pkg.version,
    MIXPANEL_TOKEN: "3ab2265c875d7978fb39c51e00c6a33d",
    APP_STORE_URL: "https://play.google.com/store/apps/details",
    PLAY_STORE_URL: "https://play.google.com/store/apps/details",

    PRODUCTS: {
        SOLO: {
            APP_URL: "",
            WEB_URL: "https://local.moonproduct.tech",
            API_URL: "https://solo.moonproduct.xyz",
            PACKAGE_NAME: "com.moonproduct.solo"
        }
    }
}